import P6SummaryChart from '../../lib/jin/jwchartlib-v0/lib/Components/Z_Projects/COMMON/P6/SummaryChart'

export default {
  P6SummaryChart
}
